// extracted by mini-css-extract-plugin
export default {"modal-inner":"FinanceDisclaimerModal__modal-inner--M69Tm"};